import { Box, Image, SlideFade, Text } from '@chakra-ui/react'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PermissionsEnum } from '../../../../utils'
import { UserContext } from '../../../providers'

interface ExampleImagePreviewProps {
  prompt: string
  src: string
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
}

const ExampleImagePreview = ({
  prompt,
  src,
  setFieldValue,
}: ExampleImagePreviewProps) => {
  const { t } = useTranslation()
  const [isHovered, setIsHovered] = useState(false)
  const { user } = useContext(UserContext)

  return (
    <Box
      height="100%"
      position="relative"
      cursor="pointer"
      borderRadius="8px"
      overflow="hidden"
      _before={{
        content: '""',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        bgGradient:
          'linear(to-b, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.6) 100%)',
        transition: 'opacity 0.5s ease-in-out',
        opacity: 0,
        borderRadius: 'inherit',
      }}
      _hover={{
        _before: {
          opacity: 1,
        },
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => {
        if (
          user?.permissions.includes(
            PermissionsEnum.RESTRICTED_SELF_MEDIA_LIBRARY_MANAGE,
          )
        ) {
          setFieldValue('prompt', prompt)
        }
      }}
    >
      <Image height="inherit" borderRadius="inherit" src={src} />
      <SlideFade in={isHovered} unmountOnExit>
        <Text
          lineHeight="1.2"
          left="24px"
          right="24px"
          top="16px"
          position="absolute"
          color="white"
          fontSize="16px"
        >
          {prompt}
        </Text>
        <Text
          bottom="16px"
          left="24px"
          position="absolute"
          color="white"
          fontWeight="500"
        >
          {t('try_this_example', 'Try this example')}
        </Text>
      </SlideFade>
    </Box>
  )
}

export default ExampleImagePreview
